export const BASE_URL = process.env.REACT_APP_BASE_URL + "admin/";
export const POS_BASE_URL = process.env.REACT_APP_BASE_URL;
export const ACTIVITY_LOG_URL = process.env.REACT_APP_ACTIVITY_LOG_API_KEY;
export const ACTIVITY_LOG_PROJECT_KEY =
  process.env.REACT_APP_ACTIVITY_LOG_PROJECT_KEY;
export const CMS_URL = process.env.REACT_APP_CMS_URL;
export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const CONNECT_SITE_URL = process.env.REACT_APP_CONNECT_SITE_URL;
export const ABLY_API_KEY = process.env.REACT_APP_ABLY_API_KEY;
export const ABLY_PREFIX = process.env.REACT_APP_ABLY_PREFIX;
export const REPORTS_SSO_URL = process.env.REACT_APP_REPORTS_SSO_URL;
